import React from "react";
import Modal from "react-bootstrap/Modal";
import DocumentLinesTable from "components/Tables/DocumentLinesTable";

export default function DocumentLinesModal({ docId, docOrder, docNumber, show, handleClose }) {
  return (
    <>
      <Modal size="xl" dialogClassName="my-modal" show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title>{docOrder + ' ' + docNumber}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DocumentLinesTable modalOpen={show} docId={docId} />
        </Modal.Body>
      </Modal>
    </>
  );
}
